import React, { PropTypes } from 'react';
import { Field } from 'redux-form';
import { TextInputField, TextAreaField, RadioButtonField } from 'common/components/form_fields';

const DetailsForm = ({ handleSubmit, onSubmit, toggle, invalid }) => (
  <form onSubmit={handleSubmit(onSubmit)} className="focus-group-details">
    <div>
      <fieldset>
        <h3>Name Your Group</h3>
        <p>The name is only visible to you and your collaborators.</p>
        <Field
          name="name"
          component={TextInputField}
          label="Focus group name"
        />
      </fieldset>
      <fieldset>
        <h3>Message to Participants</h3>
        <p>
          Tell participants why you need their help (i.e. "I'm working with crowdspring to design
          a logo for my new gift basket business and need your help picking the best design.")
          and how they can best help you. This message will appear at the top of the focus group
          page.
        </p>
        <Field
          name="purpose"
          component={TextAreaField}
          rows={5}
        />
      </fieldset>
      <fieldset>
        <h3>Share Results</h3>
        <p>
          Should participants see the results of the focus group after participating?
        </p>
        <Field
          name="share_results"
          component={RadioButtonField}
          props={{ value: true }}
          label="Yes"
        />
        <Field
          name="share_results"
          component={RadioButtonField}
          props={{ value: false }}
          label="No"
        />
      </fieldset>
    </div>
    <div className="modal-actions">
      <button type="submit" disabled={invalid} className="btn btn-primary">Next</button>
      <button type="button" onClick={toggle} className="btn btn-text">Cancel</button>
    </div>
  </form>
);

DetailsForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  toggle: PropTypes.func.isRequired,
  invalid: PropTypes.bool.isRequired,
};

export default DetailsForm;



// WEBPACK FOOTER //
// ./focus_groups/components/details_form.jsx